import { Card, makeStyles, Typography } from '@rentacenter/racstrap';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PriorityCustomerList } from './PriorityCustomerList';

export const priorityFieldVisitCustomersTestId =
  'priorityFieldVisitCustomersTestId';

const useClasses = makeStyles((theme: any) => ({
  customerListWrapper: {
    marginTop: '1rem',
    marginBottom: theme.typography.pxToRem(80),
  },
  customerList: {
    display: 'flex',
    flexDirection: 'row',
    boxSizing: 'border-box',
    borderRadius: '1rem',
  },
  header: {
    ...theme.typography.h4,
    fontSize: '1.125rem',
    fontFamily: 'OpenSans-bold',
    marginBottom: '.5rem',
  },
  cardBody: {
    padding: '0 0.5rem',
    width: '100%',
    boxSizing: 'border-box',
  },
  legentItemsContainer: {
    height: theme.typography.pxToRem(46 + 8),
    ...theme.typography.h4,
    fontSize: '1.125rem',
    fontFamily: 'OpenSans-bold',
    marginBottom: '.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export const PriorityFieldVisitCustomers = () => {
  const classes = useClasses();
  const { t } = useTranslation();

  return (
    <div className={classes.customerListWrapper}>
      <Typography component="h4" className={classes.header}></Typography>
      <Card
        className={classes.customerList}
        data-testid={priorityFieldVisitCustomersTestId}
      >
        <div className={classes.cardBody}>
          <div className={classes.legentItemsContainer}>
            {t('Priority Field Visits Results')}
          </div>
          <PriorityCustomerList />
        </div>
      </Card>
    </div>
  );
};
